'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "password"
    }, [_vm.title ? _c('h2', {
      staticClass: "password-title",
      domProps: {
        "textContent": _vm._s(_vm.title)
      }
    }) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "password-security",
      class: _vm.shakeClass,
      on: {
        "touchstart": function touchstart($event) {
          $event.stopPropagation();

          _vm.$emit('focus');
        }
      }
    }, _vm._l(6, function (item) {
      return _c('li', {
        key: item,
        on: {
          "animationend": function animationend($event) {
            _vm.onAnimationEnd(item);
          }
        }
      }, [_vm.value.length >= item ? _c('i') : _vm._e()]);
    }), 0), _vm._v(" "), _vm.allInfo ? _c('div', {
      class: _vm.errorInfo ? 'password-error-info' : 'password-info'
    }, [_vm._v(" " + _vm._s(_vm.allInfo) + " ")]) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'password',
  data: function data() {
    return {
      shakeClass: ''
    };
  },
  props: {
    info: String,
    title: String,
    value: String,
    errorInfo: String
  },
  computed: {
    allInfo: function allInfo() {
      return this.errorInfo || this.info;
    }
  },
  watch: {
    value: function value(newValue, oldValue) {
      // 从0位到1位
      if (newValue && !oldValue) {
        this.$emit('update:errorInfo', '');
      }
    },
    errorInfo: function errorInfo(newVal) {
      if (newVal) {
        this.shakeClass = 'password-shake';
      }
    }
  },
  methods: {
    onAnimationEnd: function onAnimationEnd(index) {
      if (index === 1) {
        this.shakeClass = '';
        this.$emit('input', '');
      }
    }
  }
});

exports.default = index;
